import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { motion } from "framer-motion";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { GeometriaDetail } from "@/components/landing/GeometriaDetail";
import { OilDetail } from "@/components/landing/OilDetail";
import { BrakesDetail } from "@/components/landing/BrakesDetail";
import { About } from "@/components/landing/About";
import { CtaBanner } from "@/components/landing/CtaBanner";
import { Location } from "@/components/landing/Location";
import { Footer } from "@/components/landing/Footer";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";
import { lenisRef } from "@/lib/scroll";
import { LogoFull } from "@/components/landing/Logo";

function App() {
  const [intro, setIntro] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setIntro(false), 1100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="bg-ink min-h-screen text-gray-100">
      {intro && (
        <motion.div
          className="fixed inset-0 z-[100] bg-ink flex items-center justify-center pointer-events-none"
          initial={{ y: 0 }}
          animate={{ y: "-100%" }}
          transition={{ delay: 0.55, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.85, filter: "blur(6px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          >
            <LogoFull testid="intro-logo" scale={2} />
          </motion.div>
        </motion.div>
      )}

      <Navbar />
      <main>
        <Hero />
        <Services />
        <GeometriaDetail />
        <OilDetail />
        <BrakesDetail />
        <About />
        <CtaBanner />
        <Location />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
